export const modelFilterHook = (modelId: string, subModelId?: string | null) => {
  if (subModelId) {
    switch (subModelId) {
      case 'DS200003':
        return 'MR10 (구MODLINK-T3)';
      case 'DS200004':
        return 'MT11-G';
      case 'DS200005':
        return 'MR20-KR';
      case 'DS200006':
        return 'MR20-G';
      default:
        return '';
    }
  }
  switch (modelId) {
    case 'DT100001':
      return 'T10';
    case 'DT000001':
      return 'MODLINK-T';
    case 'DT000003':
      return 'MB10 (구 MODLINK-B)';
    case 'DT000004':
      return 'MODLINK-L';
    case 'DT000002':
      return 'MT10 (구 MODLINK-T2)';
    case 'DT000006':
      return 'MT11';
    case 'DT000005':
      return 'ML10';
    case 'DT200001':
      return 'RP10-2(RELAYPOINT-P2)';
    case 'DT200002':
      return 'RP10-4(RELAYPOINT-P4)';
    case 'DT000007':
      return 'ML10-BM5';
    case 'DT000008':
      return 'MT11-BM5';
    case 'DT000009':
      return 'MR20';
    default:
      return '';
  }
};
